<button neo-menu-item [attr.aut-id]="autId()" [disabled]="disabled()">
  @if (hasIcon()) {
    <cm-icon class="menu-item-icon" [name]="icon()!" size="s" />
  }
  <ng-content />
</button>
